module.exports = __webpack_public_path__ + "img/fz.3118c415.png";